module.exports = __webpack_public_path__ + "static/img/solutionPic9.af11b14.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionPic9.png
// module id = gwzU
// module chunks = 1